// extracted by mini-css-extract-plugin
export default {"Thanks":"FoursourceThanks_Thanks__VZXUh"};